export default {
  CLOSE_VIDEO_POPUP: 'CLOSE_VIDEO_POPUP',
  OPEN_VIDEO_POPUP: 'OPEN_VIDEO_POPUP',
};
